// extracted by mini-css-extract-plugin
export var actionButton = "_8d-1";
export var actionButtons = "_8d-2";
export var actions = "_8d-0";
export var aiUnread = "_8d-10";
export var alignCenter = "_8d-h";
export var backWrapper = "_8d-3";
export var cellContainer = "_8d-4";
export var checkboxContainer = "_8d-5";
export var contentContainer = "_8d-6";
export var contentHeader = "_8d-8";
export var conversationsTableWrapper = "_8d-s";
export var draftReplyBadgeContainer = "_8d-m";
export var dropdownItem = "_8d-b";
export var dropdownItemsContainer = "_8d-a";
export var dropdownTitle = "_8d-c";
export var errorIcon = "_8d-7";
export var filter = "_8d-d";
export var gray = "_8d-i";
export var headerActionButtons = "_8d-e";
export var headerCheckboxContainer = "_8d-f";
export var icon = "_8d-j";
export var menuContainer = "_8d-k";
export var noMoreTicketsIcon = "_8d-12";
export var noMoreTicketsSubText = "_8d-13";
export var oneLine = "_8d-l";
export var optionsButton = "_8d-n";
export var plus = "_8d-o";
export var portalButtonsWrapper = "_8d-g";
export var red = "_8d-p";
export var scrolledTop = "_8d-9";
export var search = "_8d-q";
export var selectedConversationsCount = "_8d-r";
export var spinner = "_8d-t";
export var strong = "_8d-u";
export var summaryCell = "_8d-v";
export var tableContainer = "_8d-11";
export var tagContainer = "_8d-w";
export var threeDots = "_8d-x";
export var twoLines = "_8d-y";
export var unread = "_8d-z";